import { Box, Typography, Divider } from "@mui/material";
import packageIcon from "../../../../Assets/Icons/package-icon.png";
import calendarIcon from "../../../../Assets/Icons/calendar-icon.png";
import calendarCheckIcon from "../../../../Assets/Icons/calendar-check.png";
import userIcon from "../../../../Assets/Icons/user-icon.png";
import InvoiceIcon from "../../../../Assets/Icons/today-new-orders.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const SummaryItem = ({ icon, label, value, index, total, iconBg }) => {
  const isLastItem = index === total - 1;
  const isLastRowSm = index >= total - (total % 2 || 2);
  const isLastRowMd = index >= total - (total % 3 || 3);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        px: 1.5,
        py: 1.25,
        borderRight: {
          xs: "none",
          sm: !isLastItem && index % 2 === 0 ? "1px solid #E5E7EB" : "none",
          md: !isLastItem && index % 3 !== 2 ? "1px solid #E5E7EB" : "none",
        },
        borderBottom: {
          xs: !isLastItem ? "1px solid #E5E7EB" : "none",
          sm: !isLastRowSm ? "1px solid #E5E7EB" : "none",
          md: !isLastRowMd ? "1px solid #E5E7EB" : "none",
        },
      }}
    >
      <Box
        sx={{
          width: 20,
          height: 20,
          mt: 0.15,
          borderRadius: "6px",
          backgroundColor: "#F3F4F6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          border: "1px solid #E4E7EC",
        }}
      >
        <Box
          component="img"
          src={icon}
          alt={label}
          sx={{
            width: 14,
            height: 14,
            opacity: 1,
            filter: "grayscale(1) brightness(0.72) contrast(0.95)",
          }}
        />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "11px",
            lineHeight: 1.2,
            color: "#6B7280",
            mb: 0.35,
            fontWeight: 500,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: 1.25,
            color: "#111827",
            fontWeight: 600,
            wordBreak: "break-word",
          }}
        >
          {value || "-"}
        </Typography>
      </Box>
    </Box>
  );
};

const CustomerDetailsCard = ({ customerDetails }) => {
  const labelStyle = {
    fontSize: "11px",
    lineHeight: 1.2,
    color: "#6B7280",
    mb: 0.35,
    fontWeight: 500,
  };

  const valueStyle = {
    fontSize: "13px",
    lineHeight: 1.25,
    color: "#111827",
    fontWeight: 600,
    wordBreak: "break-word",
  };

  return (
    <Box
      sx={{
        mt: 1.25,
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.65,
          px: 1.5,
          py: 1.1,
        }}
      >
        <PersonOutlineIcon sx={{ fontSize: 16, color: "#374151" }} />
        <Typography
          sx={{
            fontSize: "15px",
            lineHeight: 1.2,
            color: "#111827",
            fontWeight: 600,
          }}
        >
          Customer Details
        </Typography>
      </Box>

      <Divider sx={{ borderColor: "#E5E7EB" }} />

      <Box
        sx={{
          px: 1.5,
          py: 1.25,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
          },
          gap: 1.25,
        }}
      >
        <Box>
          <Typography sx={labelStyle}>Name</Typography>
          <Typography sx={valueStyle}>{customerDetails.customer_name || "-"}</Typography>
        </Box>
        <Box>
          <Typography sx={labelStyle}>Code</Typography>
          <Typography sx={valueStyle}>{customerDetails.customer_code || "-"}</Typography>
        </Box>
        <Box>
          <Typography sx={labelStyle}>Phone</Typography>
          <Typography sx={valueStyle}>{customerDetails.customer_phone || "-"}</Typography>
        </Box>
        <Box>
          <Typography sx={labelStyle}>Email</Typography>
          <Typography sx={valueStyle}>{customerDetails.customer_email || "-"}</Typography>
        </Box>
        <Box sx={{ gridColumn: { xs: "auto", sm: "span 2", md: "span 2" } }}>
          <Typography sx={labelStyle}>Address</Typography>
          <Typography sx={valueStyle}>{customerDetails.customer_address || "-"}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

const OrderInformation = ({ orderDetails }) => {
  const summaryFields = [
    {
      label: "Invoice No",
      value: orderDetails?.invoice_number,
      icon: InvoiceIcon,
    },
    {
      label: "Invoice Date",
      value: orderDetails?.invoice_date,
      icon: calendarIcon,
    },
    {
      label: "Job No",
      value: orderDetails?.job_id,
      icon: packageIcon,
    },
    {
      label: "Order Date",
      value: orderDetails?.order_date,
      icon: calendarIcon,
    },
    {
      label: "Delivery Date",
      value: orderDetails?.delivery_date,
      icon: calendarCheckIcon,
    },
    {
      label: "Driver",
      value: orderDetails?.assigned_driver,
      icon: userIcon,
    },
    // { label: "Bay", value: orderDetails?.bay, icon: BayIcon },
  ];

  return (
    <Box sx={{ mb: 1 }}>
      <Box
        sx={{
          border: "1px solid #E5E7EB",
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
          overflow: "hidden",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
          },
        }}
      >
        {/* {summaryFields.map((item, index) => (
          <SummaryItem
            key={item.label}
            icon={item.icon}
            label={item.label}
            value={item.value}
            index={index}
            total={summaryFields.length}
          />
        ))} */}
      </Box>

      <CustomerDetailsCard customerDetails={orderDetails} />
    </Box>
  );
};

export default OrderInformation;
